// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.op_kind */
var OpKind;
(function (OpKind) {
    OpKind["STANDARD"] = "STANDARD";
    OpKind["RECEIVE"] = "RECEIVE";
    OpKind["PASSTHROUGH"] = "PASSTHROUGH";
})(OpKind || (OpKind = {}));
;
export default OpKind;
/** Zod schema for op_kind */
export const opKind = z.nativeEnum(OpKind);
//# sourceMappingURL=OpKind.js.map